<template>
    <div class="biz-contract-comp">
        <div class="contract-wrap" v-html="previewContract"></div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
    data () {
        return {
            // bizContract: null,
            previewContract: localStorage.getItem('previewContract')
        }
    },
    mounted () {
        this.$analyticsBiz.logEvent(this.$route.meta.title, { screen_name: this.$route.meta.title})
    },
    destroyed () {
        localStorage.removeItem('previewContract')
    }
}
</script>
<style lang="scss" scoped>
    .biz-contract-comp{
        .contract-wrap{
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
        }
    }
</style>


// WEBPACK FOOTER //
// src/pages/bussiness/settingCenter/contractSetting/previewContract.vue